import { CompanyEdit } from 'ui/components/agent/patterns/CompanyEdit/CompanyEdit';

/**
 * 企業情報編集ページ
 */
export const AgentEdit: React.FC = () => {
    return <CompanyEdit />;
};
